import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'core/components/modal/modal.component';
import { Itinerary } from 'core/models/itinerary';
import { ItinerariesService } from 'core/services/itineraries.service';

@Component({
  selector: 'lms-itinerary-publish-modal',
  templateUrl: './itinerary-publish-modal.component.html',
  styleUrls: ['./itinerary-publish-modal.component.scss']
})
export class ItineraryPublishModalComponent implements OnInit {
  @Input() public itinerary: Itinerary;
  @Output() public publish = new EventEmitter<any>();

  @ViewChild('modalItineraryPublish', { static: false }) public modalItineraryPublish: ModalComponent;

  constructor(public itinerariesService: ItinerariesService) {}

  ngOnInit(): void {}

  open() {
    this.modalItineraryPublish.open();
  }

  close() {
    this.modalItineraryPublish.close();
  }

  public publishItinerary(): void {
    this.close();
    this.itinerariesService
      .publishItinerary(this.itinerary)
      .then(() => {
        this.itinerary.publish.active = true;
        this.publish.emit(this.itinerary);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
      });
  }
}
